import { memo } from 'react';

import { Box, Loader } from '@betty/moonlight';

function SplashScreen() {
  return (
    <Box backgroundColor="screenBackground" absoluteFill centerContent>
      <Loader />
    </Box>
  );
}

export default memo(SplashScreen);
